'use strict';
import * as _ from 'lodash';

const CACHE_PREFIX = 'CACHED::::';
const CACHE_LENGTH_LIMIT = 100;
const CACHE_KEYS = [
  'worklist-diagram',
  'worklist-items',
  'worklist-patient-info',
  'worklist-patient-survey',
  'worklist-documents',
  'worklist-history-config'
];
const HOSPITAL = 'hospital';

export class LocalStorage {
  constructor() {
    this.localStorage = window.localStorage;
  }

  set(key, value) {
    try {
      if (this.localStorage.length > CACHE_LENGTH_LIMIT) {
        this.cleanUpStorage();
      }
      this.localStorage[key] = value;
    } catch (err) {
      console.log('cache limit exceeded, trying to cleanup');
      this.cleanUpStorage();
      try {
        this.localStorage[key] = value;
      } catch (err2) {
        console.log('cache limit still exceeded');
      }
    }
  }

  get(key, defaultValue) {
    return this.localStorage[key] || defaultValue;
  }

  delete(key) {
    delete this.localStorage[key];
  }

  setObject(key, value) {
    try {
      if (this.localStorage.length > CACHE_LENGTH_LIMIT) {
        this.cleanUpStorage();
      }
      this.localStorage[key] = JSON.stringify(value);
    } catch (err) {
      console.log('cache limit exceeded, trying to cleanup');
      this.cleanUpStorage();
      try {
        this.localStorage[key] = JSON.stringify(value);
      } catch (err2) {
        console.log('cache limit still exceeded');
      }
    }
  }

  getObject(key) {
    return JSON.parse(this.localStorage[key] || '{}');
  }

  cleanUp() {
    _.each(Object.keys(this.localStorage), (key) => {
      if (_.some(CACHE_KEYS, (x) => _.includes(key, x))) {
        delete this.localStorage[key];
      }
    });
  }

  cleanUpEntireStorageExceptHospitalCode() {
    _.each(Object.keys(this.localStorage), (key) => {
      if (key !== HOSPITAL) {
        delete this.localStorage[key];
      }
    });
  }

  cleanUpStorage() {
    try {
      let keysToClean = [];
      for (let key in this.localStorage) {
        if (key.indexOf(CACHE_PREFIX) === 0) {
          let keyToClean = false;
          CACHE_KEYS.forEach((cacheKey) => {
            if (key.indexOf(cacheKey) > 0) {
              keyToClean = true;
            }
          });

          if (keyToClean) {
            keysToClean.push(key);
          }
        }
      }

      if (!keysToClean.length) {
        return;
      }

      // Sort records by worklist id. Bigger id mean more recent record
      keysToClean.sort((left, right) => {
        let leftNum = parseInt(left.split('-').pop());
        let rightNum = parseInt(right.split('-').pop());
        return (leftNum > rightNum ? 1 : -1);
      });

      for (let i = 0; i < keysToClean.length / 2; i++) {
        delete this.localStorage[keysToClean[i]];
        console.log('Delete old cache key', keysToClean[i], i);
      }
    }
    catch (err) {
      console.log('Unable to clean local storage');
      console.log(err);
    }
  }
}



// WEBPACK FOOTER //
// ./src/scripts/services/localStorage.js